import { render, staticRenderFns } from "./QuizSlideContent.vue?vue&type=template&id=7349b3c2&scoped=true"
import script from "./QuizSlideContent.vue?vue&type=script&lang=js"
export * from "./QuizSlideContent.vue?vue&type=script&lang=js"
import style0 from "./QuizSlideContent.vue?vue&type=style&index=0&id=7349b3c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7349b3c2",
  null
  
)

export default component.exports